export const SET_SPACES = 'SET_SPACES';
export const SET_SPACE = 'SET_SPACE';
export const ADD_SPACE = 'ADD_SPACE';
export const UPDATE_SPACE = 'UPDATE_SPACE';
export const REMOVE_SPACE = 'REMOVE_SPACE';
export const CLEAR_SPACE = 'CLEAR_SPACE';
export const CLEAR_SPACES = 'CLEAR_SPACES';
